module.exports = __webpack_public_path__ + "img/check.59a493df.png";